// @flow

// Name
export const MODEL = 'importJobsPopup'

// State Configuration
export const TREE = 'soilJobsModule'
export const BRANCH = 'popupOperations'

// Model Properties
export const PROP_ID = 'id'
export const PROP_IMPORT_RESULT_ID = PROP_ID
export const PROP_ERRORS = 'errors'
export const PROP_IS_PARTIALLY_SUCCESSFUL_IMPORT = 'isPartiallySuccessfulImport'

// Response parameters
export const PARAM_HEFTY_FIELD_ID = 'hefty_field_id'
export const PARAM_REASON = 'reason'
